import { createActionGroup, emptyProps, props } from '@ngrx/store';

export type ToastType = 'success' | 'warning' | 'error';

export const toastActions = createActionGroup({
  source: 'toast',
  events: {
    ShowToast: props<{
      message: string;
      toastType?: ToastType;
      header?: string;
      icon?: string;
      duration?: number;
    }>(),
    CloseToast: emptyProps(),
  },
});
